export default "__VITE_ASSET__EEaLFkRr__"